import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 8.98718V16.75C2.5 17.4699 2.78597 18.1603 3.295 18.6693C3.80402 19.1784 4.49441 19.4643 5.21429 19.4643H18.7857C19.5056 19.4643 20.196 19.1784 20.705 18.6693C21.214 18.1603 21.5 17.4699 21.5 16.75V8.98718L13.4223 13.957C12.9946 14.2202 12.5022 14.3595 12 14.3595C11.4978 14.3595 11.0054 14.2202 10.5777 13.957L2.5 8.98718Z"
        fill={colorValue}
      />
      <path
        d="M21.5 7.393V7.25005C21.5 6.53018 21.214 5.83979 20.705 5.33076C20.196 4.82174 19.5056 4.53577 18.7857 4.53577H5.21429C4.49441 4.53577 3.80402 4.82174 3.295 5.33076C2.78597 5.83979 2.5 6.53018 2.5 7.25005V7.393L11.2889 12.8017C11.5027 12.9332 11.7489 13.0029 12 13.0029C12.2511 13.0029 12.4973 12.9332 12.7111 12.8017L21.5 7.393Z"
        fill={colorValue}
      />
    </svg>
  );
};
